import { useState } from 'react';
import { intelligenceApi } from '../lib/adapter';

/**
 * Sprint 1: UI state + adapter contract only.
 * Backend enforcement lands with the orchestration sprint.
 */
export function TakeoverControl({ conversationId, initialHandler }: { conversationId: string; initialHandler: 'ai' | 'human' | 'paused' }) {
  const [handler, setHandler] = useState(initialHandler);
  const [busy, setBusy] = useState(false);

  const takeover = async () => {
    setBusy(true);
    await intelligenceApi.takeoverConversation(conversationId);
    setHandler('human');
    setBusy(false);
  };
  const resume = async () => {
    setBusy(true);
    await intelligenceApi.resumeAi(conversationId);
    setHandler('ai');
    setBusy(false);
  };

  return (
    <div className="flex items-center gap-2">
      {handler === 'ai' ? (
        <>
          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-teal-50 border border-teal-100 text-[11px] font-bold text-teal-700">
            <span className="w-1.5 h-1.5 rounded-full bg-teal-500 animate-pulse" /> المساعد الذكي يتولى الرد ●
          </span>
          <button type="button" disabled={busy} onClick={() => void takeover()}
            className="px-3 py-1.5 rounded-lg bg-gray-900 text-white text-[11px] font-bold hover:bg-gray-800 disabled:opacity-50">
            استلام المحادثة
          </button>
        </>
      ) : (
        <>
          <div className="text-start">
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-50 border border-amber-100 text-[11px] font-bold text-amber-700">
              المساعد الذكي متوقف عن هذه المحادثة
            </span>
            <p className="text-[10px] text-gray-400 mt-1">أنت تتولى هذا العميل الآن.</p>
          </div>
          <button type="button" disabled={busy} onClick={() => void resume()}
            className="px-3 py-1.5 rounded-lg bg-teal-600 text-white text-[11px] font-bold hover:bg-teal-700 disabled:opacity-50">
            إعادة تفعيل المساعد
          </button>
        </>
      )}
    </div>
  );
}
